import { computed } from '@vue/composition-api'
import store from '@/store/'

export default () => {
  const computedData = {
    // 状态
    PICTURES_STATE: computed(() => (
      store.state.label.data.PICTURES_MANAGEMENT?.PICTURES_STATE
    )),
    // 平台类型
    PICTURES_CLASS_TYPE: computed(() => (
      store.state.label.data.PICTURES_MANAGEMENT?.PICTURES_CLASS_TYPE
    )),
    // 终端类型
    PICTURES_PLATFORM_CLASS: computed(() => (
      store.state.label.data.PICTURES_MANAGEMENT?.PICTURES_PLATFORM_CLASS
    )),
    // 移动终端类型
    PICTURES_PICTURE_TYPE: computed(() => (
      store.state.label.data.PICTURES_MANAGEMENT?.PICTURES_PICTURE_TYPE
    )),
    // 是否新开窗口
    PICTURES_TARGET: computed(() => (
      store.state.label.data.PICTURES_MANAGEMENT?.PICTURES_TARGET
    )),
    // 七牛域名
    QI_NIU_DOMAINS: computed(() => (
      store.state.label.data.QI_NIU_DOMAINS
    )),
    // 搜索表单
    SEARCH_FORM: computed(() => (
      store.state.searchForm.data
    )),
    SET_SEARCH: computed(() => (
      store._mutations.SET_SEARCH
    )),
    // 搜索表单时间
    SEARCH_FORMDAY: computed(() => (
      store.state.searchForm.date
    )),
    SET_SEARCHDAY: computed(() => (
      store._mutations.SET_SEARCHDAY
    ))
  }

  function showName(type, id) {
    const item = computedData[type].value.filter(item => item.key === id)[0]
    return (item && item.value) || '--'
  }

  return {
    ...computedData,
    showName
  }
}
